import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../../../app/token.service';
import { MainService } from './main.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PetsettingService {


  constructor(private http: HttpClient, private main: MainService,private token:TokenService) {
  }
  //fields
  async getFields(obj:any) {

    const res = await this.http.get<any>(this.main.httpUrl + '/pet/field/getfields' + obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;

    });
    return res;

  }
  async createFields(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/pet/field/createField', obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateFields(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/pet/field/updateField', obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }



  //codeValue
  async getCodeValue(b_acct_id:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/metadata/codeValue/getCodeValues'+b_acct_id).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getFieldCodeValues(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/pet/codeValue/getFieldCodeValues' + JSON.stringify(obj),  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async insertCodeValue(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/pet/codeValue/createCodeValue', obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateCodeValues(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/pet/codeValue/updateCodeValue', obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteCodeValue(obj:any) {
    const resp = await this.http.delete<any>(this.main.httpUrl + '/pet/codeValue/deleteCodeValue' + obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

}
